import { Types } from './types';
const initialState = {
    dataNFC: {
        paging: {},
        rows: [],
    },

}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_NFC:
            return {
                ...newState,
                dataNFC: action.payload
            }
        default:
            return newState
    }
}
export default reducer
